
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-profile-picture-maker",
      function () {
        return require("private-next-pages/ai-profile-picture-maker/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-profile-picture-maker"])
      });
    }
  